import React, { useEffect } from "react";
import { Redirect, RouteComponentProps } from "react-router";
import { getPreviewRedirectUrl } from "./util/getPreviewRedirectUrl";

const PreviewRedirect: React.FC<RouteComponentProps<{ id: string }>> = ({
  match,
  location
}) => {
  const id = match.params.id;
  const result = getPreviewRedirectUrl(location.search, id);

  useEffect(() => {
    if (typeof result === "object" && "url" in result) {
      if (result.external) {
        window.location.replace(result.url);
      }
    }
  }, [result]);

  if (typeof result === "object" && "message" in result) {
    return <div>{result.message}</div>;
  }

  if (typeof result === "object" && "url" in result && !result.external) {
    return <Redirect to={result.url} />;
  }

  return null;
};

export default PreviewRedirect;
